<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card elevation="0" class="rounded-lg primary--text px-3">
          <v-row class="text-start">
            <v-col md="4" lg="4">
              <div class="font-weight-medium text-subtitle-2">{{ $t("trainingCategory.trainingCategory") }}</div>
            </v-col>

            <v-col md="5" lg="5">
              <div class="font-weight-medium text-subtitle-2">{{ $t("trainingCategory.trainingSubCategories") }}</div>
            </v-col>

            <v-col md="3" lg="3" class="text-right">
              <div class="font-weight-medium text-subtitle-2 pe-3">Actions</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading && !data.length">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>

        <v-row v-else-if="!loading && data.length">
          <v-col
            cols="12"
            v-for="(trainingCategory, index) in data"
            :key="index"
          >
            <CategoryCard
              :trainingCategory="trainingCategory"
              @editTrainingCategory="edit"
              @deleteTrainingCategory="removeTrainingCategory"
              @updateErr="onError('update')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else-if="!loading && !data.length"
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CategoryCard from "./CategoryCard.vue";

import { deleteTrainingCategory } from "../methods/deleteTrainingCategory";

export default {
  name: "CategoryList",
  components: { CategoryCard },
  props: {
    data: {
      type: Array,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    removeTrainingCategory(id) {
      this.$dialog
        .confirm(this.$t("trainingCategory.confirmDelete"), { loader: true })
        .then(dialog => {
          deleteTrainingCategory(id).then(res => {
            // if (res.data) this.$emit("reFetch");
            if (res.error) {
              this.onError("delete");
            }

            dialog?.close();
          });
        })
        .catch(_ => {});
    },
    onError(type) {
      let msg = null;
      if (type === "delete") {
        msg = this.$t("deleteFailed");
      }
      if (type === "update") {
        msg = this.$t("updateFailed");
      }
      this.$emit("responseErr", msg);
    },
    edit(val) {
      if (val) {
        this.$emit("editTrainingCategoryVal", val);
      }
    },
  },
};
</script>
